export const getImageUrl = (image: string): string => {
    return `${process.env.REACT_APP_ORIGIN}/images/${image}`;
}